import { z } from "zod";

export const appointmentCancellationReasonDtoSchema = z.object({
  id: z.number(),
  note: z.string(),
  appointmentCancellationSectionId: z.number(),
  appointmentCancellationReasonTypeId: z.number(),
});

export type TAppointmentCancellationReasonDto = z.infer<typeof appointmentCancellationReasonDtoSchema>;
